import { useQuery, useQueryClient } from "@tanstack/react-query";

import type { App } from "../core/domain/entities/app";
import { useNavigationApi } from "../hooks";

export const allAppsQueryKey = ["navigation/organization/apps"];

const useQueryAccessibleApps = () => {
  const { api } = useNavigationApi();

  return useQuery<App[]>({
    queryKey: allAppsQueryKey,
    queryFn: () => api.navigation.getAccessibleApps(),
  });
};

export const useInvalidateAccessibleApps = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: allAppsQueryKey,
    });
};

export default useQueryAccessibleApps;
